import { Snackbar } from "@material-ui/core";

import { useDispatch } from "react-redux";

import { useEffect, useState } from "react";

import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

import { useNavigate } from "react-router-dom";
import RateService from "../../services/RateService";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DocumentService from "../../services/DocumentService";

const AddTaxAndChargeToFacture = () => {
  // const dispatch = useDispatch();
  const navigate = useNavigate();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();

  const [availableRates, setAvailableRates] = useState([]);
  const [allRates, setAllRates] = useState([]);

  const [rateSelectPlaceHolder, setRateSelectPlaceHolder] = useState(
    "Choisir une taxe ou frais"
  );
  const [rateChoosen, setRateChoosen] = useState(null);
  const [rateName, setRateName] = useState("");
  const [rateCode, setRateCode] = useState("");
  const [rateType, setRateType] = useState("");
  const [rateTypeTax, setRateTypeTax] = useState("");
  const [rateTypeTVA, setRateTypeTVA] = useState("");

  const [valueRate, setValueRate] = useState();
  const [refBill, setRefBill] = useState("");

  const [rateTableData, setRateTableData] = useState([]);
  const [selectedOptionRate, setSelectedOptionRate] = useState(null);
  const animatedComponents = makeAnimated();
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };
  useEffect(() => {
    RateService.getAllRatesByIdUserAndIsDeletedAndTypeTax(
      getCurrentUserId(),
      0,
      2
    ).then((result) => {
      console.log("result", result.data["success"]);
      if (result.data["success"]) {
        setAvailableRates(result.data["success"]);
      } else {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :erreur serveur ");
      }
    });
  }, []);
  useEffect(() => {
    setAllRates([]);

    availableRates &&
      availableRates.map((element, i) => {
        setAllRates((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: {
              code: element.code,
              type: element.type,
              typeTVA: element.typeTVA,
              typeTax: element.typeTax,
            },
          },
        ]);
      });
  }, [availableRates]);
  const onChangeSelected = (selectedOption) => {
    console.log("selected", selectedOption);
    setSelectedOptionRate(selectedOption);
    setRateChoosen(selectedOption.value);
    setRateName(selectedOption.label);
    setRateCode(selectedOption.customElements.code);
    setRateType(selectedOption.customElements.type);
    setRateTypeTax(selectedOption.customElements.typeTax);
    setRateTypeTVA(selectedOption.customElements.typeTVA);
    setRateSelectPlaceHolder(selectedOption.label);
  };
  const onChangeValueRateHandler = (event) => {
    setValueRate(event.target.value);
  };
  const onChangeRefBillHandler = (event) => {
    setRefBill(event.target.value);
  };
  const onAddTaxeToList = (event) => {
    if (rateChoosen === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un taxe ");
    }
    if (valueRate == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le valeur est vide ! ");
    } else {
      setRateTableData((previoustate) => [
        ...previoustate,
        {
          idRate: rateChoosen,
          name: rateName,
          value: valueRate,
          code: rateCode,
          type: rateType,
          typeTax: rateTypeTax,
          typeTVA: rateTypeTVA,
          refBill: refBill,
        },
      ]);
      setRefBill("");
      setRateChoosen(null);
      setRateSelectPlaceHolder("choisir une taxe ou frais");
      setRateName("");
      setRateCode("");
      setRateType("");
      setValueRate("");
    }
  };
  const columns = [
    {
      dataField: "code",
      text: "Code",
    },
    {
      dataField: "typeTax",
      text: "Type",
      formatter: buttonFormatter,
    },
    {
      dataField: "name",
      text: "Libellé",
    },
    {
      dataField: "value",
      text: "valeur",
    },
    {
      dataField: "idRate",
      text: "Supprimer",
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("rateTableData cell", rateTableData);

          setRateTableData(
            rateTableData.filter((item) => item.idRate !== row.idRate)
          );
        },
      },
    },
  ];

  function buttonFormatter(cell, row) {
    if (row.typeTax === 1) {
      if (row.typeTVA === 1) {
        return <span>Tax, avant TVA</span>;
      } else if (row.typeTVA === 2) {
        return <span>Tax, après TVA</span>;
      }
    } else if (row.typeTax === 2) {
      if (row.type === 1) {
        return <span>Charge, avec facture</span>;
      } else if (row.type === 2) {
        return <span>Charge, sans facture</span>;
      }
    }
  }
  const blocRefFacture = () => {
    if (rateTypeTax === 2 && rateType === 1) {
      return (
        <div className="col-md-5">
          <label>Référence facture:</label>
          <input
            type="Ref"
            className="form-control"
            placeholder="Ajouter Référence"
            value={refBill}
            onChange={onChangeRefBillHandler}
          />
        </div>
      );
    } else {
      return <div className="col-md-5"></div>;
    }
  };
  const blocRates = () => {
    if (rateChoosen !== null) {
      return (
        <div className="row">
          <div className="col-md-5">
            <label>Valeur:</label>
            <input
              onChange={onChangeValueRateHandler}
              type="number"
              value={valueRate}
              min="0"
              id="unitPrice"
              className="form-control"
            />
          </div>
          {blocRefFacture()}

          <div className="col-md-2">
            <br />
            <label> </label>
            <button class="btn btn-dark  float-right" onClick={onAddTaxeToList}>
              <i class="fas fa-plus"></i>
              Ajouter taxe
            </button>
          </div>
        </div>
      );
    }
  };

  const onValidTaxHandler = () => {
    let rateModel = {
      ref: sessionStorage.getItem("idTax"),
      idUser: getCurrentUserId(),
      ratePPps: rateTableData,
    };
    console.log("rateModel", rateModel);
    if (sessionStorage.getItem("typeToTax") === "Devis") {
      DocumentService.addRateToDevis(rateModel).then((result) => {
        console.log("result", result);
        if (result.data["success"]) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/allQuotation`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      });
    } else if (sessionStorage.getItem("typeToTax") === "BC") {
      DocumentService.addRateToBdc(rateModel).then((result) => {
        console.log("result", result.data["success"]);
        if (result.data["success"]) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/bonsDeCommande`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      });
    } else if (sessionStorage.getItem("typeToTax") === "Facture") {
      DocumentService.addRateToFacture(rateModel).then((result) => {
        console.log("result", result);
        if (result.data["success"]) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/factures`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      });
    }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  function nameDocument() {
    if (sessionStorage.getItem("typeToTax") === "Devis") {
      return <b>Devis</b>;
    } else if (sessionStorage.getItem("typeToTax") === "BC") {
      return <b>Bon de commande</b>;
    } else if (sessionStorage.getItem("typeToTax") === "Facture") {
      return <b>Facture</b>;
    }
  }
  function handleTableChange() {
    return rateTableData;
  }
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">
                  Ajouter Tax au {nameDocument()}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title">
                    {" "}
                    Ajouter un Tax / Charge au {nameDocument()}
                  </h5>
                </div>
                <div className="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Choisir un taxe ou frais</label>
                        <Select
                          styles={styles}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionRate}
                          onChange={onChangeSelected}
                          options={allRates}
                          placeholder={rateSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                  {blocRates()}
                  <br />{" "}
                  <div className="row">
                    <div className="col-md-12">
                      {rateTableData && (
                        <ToolkitProvider
                          keyField="rateTable"
                          data={rateTableData}
                          columns={columns}
                          onTableChange={handleTableChange}
                        >
                          {(props) => (
                            <div>
                              <div className="row">
                                <BootstrapTable
                                  {...props.baseProps}
                                  striped
                                  hover
                                  condensed
                                />
                              </div>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </div>
                  </div>
                </div>
                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidTaxHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AddTaxAndChargeToFacture;
